/**
 * @generated SignedSource<<eb74f5fdb698a05d45e6cd70399d1d7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ValveManufacturerInputValveManufacturersQuery$variables = {};
export type ValveManufacturerInputValveManufacturersQueryVariables = ValveManufacturerInputValveManufacturersQuery$variables;
export type ValveManufacturerInputValveManufacturersQuery$data = {
  readonly valveManufacturers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type ValveManufacturerInputValveManufacturersQueryResponse = ValveManufacturerInputValveManufacturersQuery$data;
export type ValveManufacturerInputValveManufacturersQuery = {
  variables: ValveManufacturerInputValveManufacturersQueryVariables;
  response: ValveManufacturerInputValveManufacturersQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ValveManufacturerConnection",
    "kind": "LinkedField",
    "name": "valveManufacturers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValveManufacturerEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ValveManufacturer",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ValveManufacturerInputValveManufacturersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ValveManufacturerInputValveManufacturersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6e096abd51ede4977e4a51b3216824e7",
    "id": null,
    "metadata": {},
    "name": "ValveManufacturerInputValveManufacturersQuery",
    "operationKind": "query",
    "text": "query ValveManufacturerInputValveManufacturersQuery {\n  valveManufacturers {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "866cdcaf6693897bfd21c2cd741f48a4";

export default node;
